import { render, staticRenderFns } from "./SourceOfWealth.vue?vue&type=template&id=acf87538"
import script from "./SourceOfWealth.vue?vue&type=script&lang=js"
export * from "./SourceOfWealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports